const FaceTecStringsES = {
  FaceTec_accessibility_cancel_button: "Cancelar",

  FaceTec_feedback_center_face: "Centre su rostro",
  FaceTec_feedback_face_not_found: "Enmarque su rostro",
  FaceTec_feedback_move_phone_away: "Alejese",
  FaceTec_feedback_move_away_web: "Alejese",
  FaceTec_feedback_move_phone_closer: "Acerquese",
  FaceTec_feedback_move_phone_to_eye_level:
    "Mueva el telefono al nivel de sus ojos",
  FaceTec_feedback_move_to_eye_level_web: "Mire directamente a la cámara",
  FaceTec_feedback_face_not_looking_straight_ahead: "Mire hacia adelante",
  FaceTec_feedback_face_not_upright: "Mantenga la cabeza recta",
  FaceTec_feedback_face_not_upright_mobile: "Mantenga la cabeza recta",
  FaceTec_feedback_hold_steady: "Mantengase estable",
  FaceTec_feedback_move_web_closer: "Acerquese",
  FaceTec_feedback_move_web_even_closer: "Acerquese más",
  FaceTec_feedback_use_even_lighting: "Manten la cara ligeramente mas uniforme",

  FaceTec_instructions_header_ready_desktop:
    "Da click en comenzar y sigue las instrucciones.",
  FaceTec_instructions_header_ready_1_mobile: "Da click en comenzar",
  FaceTec_instructions_header_ready_2_mobile: "y sigue las instrucciones",
  FaceTec_instructions_message_ready_desktop: "",
  FaceTec_instructions_message_ready_1_mobile: "",
  FaceTec_instructions_message_ready_2_mobile: "",
  FaceTec_instructions_message_ready: "",
  FaceTec_action_im_ready: "COMENZAR",
  FaceTec_presession_frame_your_face: "Enmarca tu cara en el óvalo",
  FaceTec_presession_look_straight_ahead: "Mira hacia adelante",
  FaceTec_presession_hold_steady3: "Manténgalo firme durante: 3",
  FaceTec_presession_hold_steady2: "Manténgalo firme durante: 2",
  FaceTec_presession_hold_steady1: "Manténgalo firme durante: 1",
  FaceTec_presession_eyes_straight_ahead: "Mira hacia adelante",
  FaceTec_presession_remove_dark_glasses: "Quítate los lentes oscuros",
  FaceTec_presession_neutral_expression: "Expresión neutral, sin sonreír",
  FaceTec_presession_conditions_too_bright: "Condiciones muy brillantes",
  FaceTec_presession_brighten_your_environment: "Ilumina tu entorno",

  FaceTec_result_facescan_upload_message:
    "Cargando<br/>encriptado<br/>de cara en 3D",
  FaceTec_result_idscan_upload_message:
    "Cargando<br/>encriptado<br/>del documento de identidad",

  FaceTec_retry_header: "Intentemos de nuevo",
  FaceTec_retry_subheader_message: "Revise su entorno antes de continuar",
  FaceTec_retry_your_image_label: "Su Selfie",
  FaceTec_retry_ideal_image_label: "Pose ideal",
  FaceTec_retry_instruction_message_1:
    "Manten un rostro neutral. Evita sonreir o hablar. Elimina obstrucciones como lentes o gorras.",
  FaceTec_retry_instruction_message_2:
    "Tu rostro debe mantener una iluminación pareja, y la debes mantener al nivel de la cámara durante la prueba.",
  FaceTec_retry_instruction_message_3: "",
  FaceTec_action_ok: "OK",
  FaceTec_action_try_again: "Intentemos de nuevo",

  FaceTec_device_incompatible_header: "<b>Dispositivo no compatible</b>",
  FaceTec_device_incompatible_message:
    "Parece haber un problema con su dispositivo. Inténtelo desde un dispositivo diferente,<br> o visite <a href='https://livenesscheckhelp.com/' target='_blank' style='text-decoration: underline;'>LivenessCheckHelp.com</a> para obtener consejos sobre cómo reparar este dispositivo.",
  FaceTec_device_incompatible_action: "Inténtalo de nuevo",

  FaceTec_camera_feed_issue_header:
    "<b>Problema al cifrar la transmisión de la cámara</b>",
  FaceTec_camera_feed_issue_header_mobile:
    "<b>Problema al cifrar<br/>la transmisión de la cámara</b>",
  FaceTec_camera_feed_issue_subheader_message:
    "Este sistema no se puede verificar debido a lo siguiente:",
  FaceTec_camera_feed_issue_subheader_message_mobile:
    "Esta aplicación bloquea las configuraciones de cámaras web sospechosas.<br/><a href='https://livenesscheckhelp.com/' target='_blank' style='text-decoration:underline; pointer-events:all;'>Leer más aquí</a>.",
  FaceTec_camera_feed_issue_table_header_1: "Posible problema",
  FaceTec_camera_feed_issue_table_header_2: "Reparar",
  FaceTec_camera_feed_issue_table_row_1_cell_1_firefox_permissions_error:
    "Los permisos de la cámara no se recuerdan en Firefox.",
  FaceTec_camera_feed_issue_table_row_1_cell_2_firefox_permissions_error:
    "Marque Recordar permisos.",
  FaceTec_camera_feed_issue_table_row_1_cell_1:
    "La cámara ya está siendo utilizada por otra aplicación.",
  FaceTec_camera_feed_issue_table_row_1_cell_2: "Cierre la otra aplicación.",
  FaceTec_camera_feed_issue_table_row_2_cell_1:
    "Una aplicación de terceros está modificando el video.",
  FaceTec_camera_feed_issue_table_row_2_cell_2:
    "Cierre/Desinstale la otra aplicación.",
  FaceTec_camera_feed_issue_table_row_3_cell_1:
    "El hardware no se puede asegurar.",
  FaceTec_camera_feed_issue_table_row_3_cell_2:
    "Utilice un dispositivo diferente.",
  FaceTec_camera_feed_issue_subtable_message:
    "Esta aplicación bloquea las configuraciones de cámaras web sospechosas. <a href='https://livenesscheckhelp.com/' target='_blank' style='text-decoration:underline;'>Leer más</a>.",
  FaceTec_camera_feed_issue_action: "Inténtalo de nuevo",
  FaceTec_camera_feed_issue_action_firefox_permissions_error: "OK",

  FaceTec_camera_permission_header: "Habilite su cámara",
  FaceTec_camera_permission_message:
    "Los permisos de su cámara están deshabilitados.<br/>Verifique su sistema operativo y la configuración del navegador.",
  zoom_browser_camera_help_action_link:
    "https://dev.facetec.com/zoomsdk/#/browser-camera-help",
  FaceTec_camera_permission_launch_settings: "OK",

  FaceTec_enter_fullscreen_header: "Modo de selfie de pantalla completa",
  FaceTec_enter_fullscreen_message:
    "Antes de comenzar, haga clic en el botón de abajo para abrir el modo de pantalla completa",
  FaceTec_enter_fullscreen_action: "Abrir pantalla completa",

  FaceTec_initializing_camera: "Iniciando camara...",
  FaceTec_initializing_camera_still_loading:
    "Encriptación de la transmisión de la cámara...",

  FaceTec_idscan_type_selection_header: "Seleccione su<br>tipo de documento",
  FaceTec_action_select_id_card: "FOTO",
  FaceTec_action_select_passport: "PASAPORTE",
  FaceTec_action_continue: "CONTINUAR",
  FaceTec_idscan_capture_id_card_front_instruction_message:
    "Mostrar frente de identificación con foto",
  FaceTec_idscan_capture_id_card_back_instruction_message:
    "Mostrar el reverso de la identificación con foto",
  FaceTec_idscan_capture_passport_instruction_message:
    "Mostrar la pagina del pasaporte con foto",
  FaceTec_idscan_capture_id_front_instruction_message:
    "Mostrar frente de identificación",
  FaceTec_idscan_capture_id_back_instruction_message:
    "Mostrar reverso de identificación",
  FaceTec_action_take_photo: "TOMAR FOTO",
  FaceTec_idscan_review_id_card_front_instruction_message:
    "Confirme si la foto es clara y legible",
  FaceTec_idscan_review_id_card_back_instruction_message:
    "Confirme si la foto es clara y legible",
  FaceTec_idscan_review_passport_instruction_message:
    "Confirme si la foto es clara y legible",
  FaceTec_idscan_review_id_front_instruction_message:
    "Confirme si la foto es clara y legible",
  FaceTec_idscan_review_id_back_instruction_message:
    "Confirme si la foto es clara y legible",
  FaceTec_action_accept_photo: "ACEPTAR",
  FaceTec_action_retake_photo: "VOLVER A TOMAR",
  FaceTec_idscan_ocr_confirmation_main_header: "Revisar y confirmar",
  FaceTec_action_confirm: "CONFIRMAR INFO",
  FaceTec_idscan_additional_review_message: "Revisión adicional<br/>requerida",
  FaceTec_result_idscan_unsuccess_message:
    "Su foto<br/>No coincide<br>Con la cara del usuario",

  FaceTec_result_idscan_success_front_side_message:
    "Escaneo de identificación completo",
  FaceTec_result_idscan_success_front_side_back_next_message:
    "Frente de identificación<br/>escaneado",
  FaceTec_result_idscan_success_back_side_message:
    "Escaneo de identificación completo",
  FaceTec_result_idscan_success_passport_message:
    "Escaneo de pasaporte completo",
  FaceTec_result_idscan_success_user_confirmation_message:
    "Escaneo de identificación<br/>completo",
  FaceTec_result_idscan_success_additional_review_message:
    "Captura de identificación<br/>completa",
  FaceTec_result_idscan_retry_face_did_not_match_message:
    "El rostro no coincidió<br/>suficientemente",
  FaceTec_result_idscan_retry_id_not_fully_visible_message:
    "Documento de identificación<br/>no completamente visible",
  FaceTec_result_idscan_retry_ocr_results_not_good_enough_message:
    "Texto de identificación no legible",
  FaceTec_result_idscan_retry_id_type_not_suppported_message:
    "Tipo de identificación no coincide<br/>Por favor intente de nuevo",
  FaceTec_result_idscan_retry_barcode_not_read_message:
    "Código de barras no se pudo escanear<br/>Por favor intente de nuevo",

  FaceTec_result_success_message: "LISTO!",
};

const FaceTecStringsEN = {
  FaceTec_accessibility_cancel_button: "Cancel",

  FaceTec_feedback_center_face: "Center your Face",
  FaceTec_feedback_face_not_found: "Frame Your Face",
  FaceTec_feedback_move_phone_away: "Move Away",
  FaceTec_feedback_move_away_web: "Move Away",
  FaceTec_feedback_move_phone_closer: "Move Closer",
  FaceTec_feedback_move_phone_to_eye_level: "Move Phone To Eye Level",
  FaceTec_feedback_move_to_eye_level_web: "Look Straight Into Camera",
  FaceTec_feedback_face_not_looking_straight_ahead: "Look Straight Ahead",
  FaceTec_feedback_face_not_upright: "Hold Your Head Straight",
  FaceTec_feedback_face_not_upright_mobile: "Keep Head Straight",
  FaceTec_feedback_hold_steady: "Hold Steady",
  FaceTec_feedback_move_web_closer: "Move Face Closer & Fill Oval",
  FaceTec_feedback_move_web_even_closer: "Even Closer",
  FaceTec_feedback_use_even_lighting: "Light Face More Evenly",

  FaceTec_instructions_header_ready_desktop: "Get Ready For Your Video Selfie",
  FaceTec_instructions_header_ready_1_mobile: "Get Ready For",
  FaceTec_instructions_header_ready_2_mobile: "Your Video Selfie",
  FaceTec_instructions_message_ready_desktop: "",
  FaceTec_instructions_message_ready_1_mobile: "",
  FaceTec_instructions_message_ready_2_mobile: "",

  FaceTec_action_im_ready: "I'M READY",
  FaceTec_presession_frame_your_face: "Frame Your Face In The Oval",
  FaceTec_presession_look_straight_ahead: "Look Straight Ahead",
  FaceTec_presession_hold_steady3: "Hold Steady for: 3",
  FaceTec_presession_hold_steady2: "Hold Steady for: 2",
  FaceTec_presession_hold_steady1: "Hold Steady for: 1",
  FaceTec_presession_eyes_straight_ahead: "Look Straight Ahead",
  FaceTec_presession_remove_dark_glasses: "Remove Dark Glasses",
  FaceTec_presession_neutral_expression: "Neutral Expression, No Smiling",
  FaceTec_presession_conditions_too_bright: "Conditions Too Bright",
  FaceTec_presession_brighten_your_environment: "Brighten Your Environment",

  FaceTec_result_facescan_upload_message:
    "Uploading<br/>Encrypted<br/>3D FaceScan",
  FaceTec_result_idscan_upload_message:
    "Uploading<br/>Encrypted<br/>ID Document",

  FaceTec_retry_header: "Let's Try That Again",
  FaceTec_retry_subheader_message: "We Need a Clearer Video Selfie",
  FaceTec_retry_your_image_label: "Your Selfie",
  FaceTec_retry_ideal_image_label: "Ideal Pose",
  FaceTec_retry_instruction_message_1: "No Glare or Extreme Lighting",
  FaceTec_retry_instruction_message_2: "Neutral Expression, No Smiling",
  FaceTec_retry_instruction_message_3: "Too Blurry, Clean Camera",
  FaceTec_action_try_again: "TRY AGAIN",

  FaceTec_camera_feed_issue_header: "Issue Securing Camera Feed",
  FaceTec_camera_feed_issue_header_mobile: "Issue Securing<br/>Camera Feed",
  FaceTec_camera_feed_issue_subheader_message_mobile:
    "This App blocks suspicious webcam configurations.<br/><a href='https://livenesscheckhelp.com/' target='_blank' style='text-decoration:underline; pointer-events:all;'>Learn More Here</a>.",
  FaceTec_camera_feed_issue_subheader_message:
    "This system cannot be verified due to the following:",
  FaceTec_camera_feed_issue_table_header_1: "Possible Issue",
  FaceTec_camera_feed_issue_table_header_2: "Fix",
  FaceTec_camera_feed_issue_table_row_1_cell_1_firefox_permissions_error:
    "Camera permissions not remembered in Firefox.",
  FaceTec_camera_feed_issue_table_row_1_cell_2_firefox_permissions_error:
    "Check Remember Permissions.",
  FaceTec_camera_feed_issue_table_row_1_cell_1:
    "Camera already in use by another App.",
  FaceTec_camera_feed_issue_table_row_1_cell_2: "Close the other App.",
  FaceTec_camera_feed_issue_table_row_2_cell_1:
    "A 3rd-Party App is modifying the video.",
  FaceTec_camera_feed_issue_table_row_2_cell_2:
    "Close/Uninstall the other App.",
  FaceTec_camera_feed_issue_table_row_3_cell_1:
    "Hardware not capable of being secured.",
  FaceTec_camera_feed_issue_table_row_3_cell_2: "Use a different Device.",
  FaceTec_camera_feed_issue_subtable_message:
    "This App blocks suspicious webcam configurations. <a href='https://livenesscheckhelp.com/' target='_blank' style='text-decoration:underline; pointer-events:all;'>Learn More Here</a>.",
  FaceTec_camera_feed_issue_action: "TRY AGAIN ANYWAY",
  FaceTec_camera_feed_issue_action_firefox_permissions_error: "OK",

  FaceTec_camera_permission_header: "Enable Camera",
  FaceTec_camera_permission_message:
    "Camera permissions disabled.<br/>Please check your operating system and browser settings.",
  FaceTec_action_ok: "OK",

  FaceTec_enter_fullscreen_header: "Full Screen Selfie Mode",
  FaceTec_enter_fullscreen_message:
    "Before we begin, please click the button below to open full screen mode.",
  FaceTec_enter_fullscreen_action: "OPEN FULL SCREEN",

  FaceTec_initializing_camera: "Starting camera...",

  FaceTec_idscan_type_selection_header: "Prepare to Scan<br/>Your ID Document",
  FaceTec_action_continue: "CONTINUE",
  FaceTec_idscan_capture_id_front_instruction_message: "Show Front of ID",
  FaceTec_idscan_capture_id_back_instruction_message: "Show Back of ID",
  FaceTec_action_take_photo: "TAKE PHOTO",
  FaceTec_idscan_review_id_front_instruction_message:
    "Confirm Photo is Clear & Legible",
  FaceTec_idscan_review_id_back_instruction_message:
    "Confirm Photo is Clear & Legible",
  FaceTec_action_accept_photo: "ACCEPT",
  FaceTec_action_retake_photo: "RETAKE",
  FaceTec_idscan_ocr_confirmation_main_header: "Review & Confirm",
  FaceTec_action_confirm: "CONFIRM INFO",
  FaceTec_idscan_additional_review_message: "Additional Review<br/>Required",

  FaceTec_result_idscan_unsuccess_message:
    "ID Photo<br/>Did Not Match<br>User's Face",

  FaceTec_result_idscan_success_front_side_message: "ID Scan Complete",
  FaceTec_result_idscan_success_front_side_back_next_message:
    "Front of ID<br/>Scanned",
  FaceTec_result_idscan_success_back_side_message: "ID Scan Complete",
  FaceTec_result_idscan_success_passport_message: "Passport Scan Complete",
  FaceTec_result_idscan_success_user_confirmation_message:
    "Photo ID Scan<br/>Complete",
  FaceTec_result_idscan_success_additional_review_message:
    "ID Photo Capture<br/>Complete",
  FaceTec_result_idscan_retry_face_did_not_match_message:
    "Face Didn't Match<br/>Highly Enough",
  FaceTec_result_idscan_retry_id_not_fully_visible_message:
    "ID Document<br/>Not Fully Visible",
  FaceTec_result_idscan_retry_ocr_results_not_good_enough_message:
    "ID Text Not Legible",
  FaceTec_result_idscan_retry_id_type_not_suppported_message:
    "ID Type Mismatch<br/>Please Try Again",
  FaceTec_result_idscan_retry_barcode_not_read_message:
    "Barcode Failed To Scan<br/>Please Try Again",

  FaceTec_result_success_message: "Success!",
};

module.exports = { FaceTecStringsES, FaceTecStringsEN };
